import React from "react";
import { injectIntl } from "react-intl";
import messages from "./data-reporting-messages";
import SubSection from "../sub-section";

import "./data-reporting.scss";

const block = "data-reporting";
const DataReportingWithFlagOn = ({ intl: { formatMessage } }) => {
  const generateYourReport = messages.generateYourReportWithFlag;
  const timeToCompleteReportRequest =
    messages.timeToCompleteReportRequestWithFlag;
  return (
    <SubSection
      className={block}
      headerText={formatMessage(messages.dataReporting)}
    >
      <ul className={`${block}__list`}>
        <li className={`${block}__list-item`}>
          {formatMessage(generateYourReport)}
        </li>
        <li className={`${block}__list-item`}>
          {formatMessage(timeToCompleteReportRequest)}
        </li>
      </ul>
    </SubSection>
  );
};

export { DataReportingWithFlagOn };
export default injectIntl(DataReportingWithFlagOn);
